import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  input,
  output,
} from '@angular/core';
import {
  ResizeMoveTableInterface,
  ResizeStartTableInterface,
} from '../../types';

@Component({
  selector: 'ui-resize-handler',
  imports: [],
  templateUrl: './resize-handler.component.html',
  styleUrl: './resize-handler.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResizeHandlerComponent {
  columnIndex = input.required<number>();

  resizeStart = output<ResizeStartTableInterface>();
  resizeMove = output<ResizeMoveTableInterface>();
  resizeEnd = output<void>();

  isResizing = false;
  startX = 0;

  onMouseDown(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    this.isResizing = true;
    this.startX = event.clientX;

    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';

    this.resizeStart.emit({
      columnIndex: this.columnIndex(),
      startX: event.clientX,
    });
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.isResizing) return;

    const deltaX = event.clientX - this.startX;
    this.startX = event.clientX;

    this.resizeMove.emit({
      columnIndex: this.columnIndex(),
      deltaX: deltaX,
    });
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    if (!this.isResizing) return;

    this.isResizing = false;
    document.body.style.userSelect = '';
    document.body.style.cursor = '';

    this.resizeEnd.emit();
  }
}
